import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const blockedTankSoftRule: StowageRuleBM = {
    id: StowageRuleId.BlockedTankSoftRule,
    name: 'A cargo should not be stowed in a blocked tank.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Stowed weight',
                            fieldPath: 'getStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is tank blocked',
                            fieldPath: 'isTankBlocked',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Blocked tank',
    },
};
